(() => {
  const instances = new WeakMap();
  let youtubeReady;
  function loadYouTube() {
    if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
    if (!youtubeReady) youtubeReady = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        try { if (typeof previous === 'function') previous(); }
        finally { resolve(window.YT); }
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = reject;
        document.head.appendChild(script);
      }
    });
    return youtubeReady;
  }
  function initAutoplay(root, motion) {
    const states = new Map();
    let disposed = false;
    const media = root.querySelectorAll('.bm-mat-story video, .bm-product-reviews video, .bm-product-reviews iframe[src*="youtube.com/embed/"]');
    const shouldPlay = (state) => state.visible && !document.hidden && !motion.matches;
    const sync = (element, state) => {
      if (element.tagName === 'VIDEO') {
        if (shouldPlay(state)) {
          element.muted = true;
          const playing = element.play();
          if (playing) playing.catch(() => {});
        } else element.pause();
      } else if (state.ready) {
        if (shouldPlay(state)) { state.player.mute(); state.player.playVideo(); }
        else state.player.pauseVideo();
      }
    };
    const initPlayer = (element, state) => {
      if (state.loading) return;
      state.loading = true;
      const url = new URL(element.src);
      url.searchParams.set('autoplay', '1');
      element.src = url.toString();
      loadYouTube().then((YT) => {
        if (disposed || !element.isConnected) return;
        state.player = new YT.Player(element, { events: {
          onReady: (event) => {
            if (disposed) return;
            state.player = event.target;
            state.ready = true;
            event.target.mute();
            sync(element, state);
          }
        } });
      }).catch(() => { state.loading = false; });
    };
    media.forEach((element) => {
      const state = { visible: false, ready: false, loading: false, player: null };
      states.set(element, state);
      if (element.tagName === 'VIDEO') {
        element.defaultMuted = true;
        element.muted = true;
        element.playsInline = true;
        element.setAttribute('muted', '');
        element.setAttribute('playsinline', '');
      } else {
        const url = new URL(element.src);
        url.searchParams.set('enablejsapi', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('origin', location.origin);
        element.src = url.toString();
      }
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.3;
        if (entry.target.tagName !== 'VIDEO' && shouldPlay(state)) initPlayer(entry.target, state);
        sync(entry.target, state);
      });
    }, { threshold: [0, 0.3] });
    media.forEach((element) => observer.observe(element));
    const syncAll = () => states.forEach((state, element) => {
      if (element.tagName !== 'VIDEO' && shouldPlay(state)) initPlayer(element, state);
      sync(element, state);
    });
    document.addEventListener('visibilitychange', syncAll);
    motion.addEventListener('change', syncAll);
    return () => {
      disposed = true;
      observer.disconnect();
      document.removeEventListener('visibilitychange', syncAll);
      motion.removeEventListener('change', syncAll);
      states.forEach((state, element) => {
        if (element.tagName === 'VIDEO') element.pause();
        else if (state.player && state.ready) state.player.destroy();
      });
    };
  }
  function init(scope) {
    scope.querySelectorAll('.bm-product--butter-it').forEach((root) => {
      if (instances.has(root) || !('IntersectionObserver' in window)) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const revealItems = root.querySelectorAll('.bm-mat-course-grid article, .bm-mat-support > div, .bm-mat-section-head');
      const reveal = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) { target.classList.add('bm-mat-visible'); reveal.unobserve(target); }
        });
      }, { threshold: 0.08 });
      revealItems.forEach((item) => { item.classList.add('bm-mat-reveal'); reveal.observe(item); });
      const syncMotion = () => root.classList.toggle('bm-mat-motion', !motion.matches);
      syncMotion();
      motion.addEventListener('change', syncMotion);
      const steps = [...root.querySelectorAll('[data-bm-story-step]')];
      const visibility = new Map();
      const stepObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
        const active = [...visibility].sort((a, b) => b[1] - a[1])[0];
        if (!active || active[1] === 0) return;
        steps.forEach((step) => step.classList.toggle('is-current', step === active[0]));
        const number = root.querySelector('[data-bm-story-number]');
        if (number) number.textContent = active[0].dataset.bmStoryStep;
      }, { rootMargin: '-15% 0px -25% 0px', threshold: [0, .15, .4, .7] });
      steps.forEach((step) => stepObserver.observe(step));
      const stopAutoplay = initAutoplay(root, motion);
      instances.set(root, () => {
        reveal.disconnect(); stepObserver.disconnect();
        motion.removeEventListener('change', syncMotion);
        stopAutoplay();
        root.classList.remove('bm-mat-motion'); instances.delete(root);
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.bm-product--butter-it').forEach((root) => instances.get(root)?.());
  });
})();
